import { render, staticRenderFns } from "./LeftBehindIndicators.vue?vue&type=template&id=122fc3f3&scoped=true"
import script from "./LeftBehindIndicators.vue?vue&type=script&lang=js"
export * from "./LeftBehindIndicators.vue?vue&type=script&lang=js"
import style0 from "./LeftBehindIndicators.vue?vue&type=style&index=0&id=122fc3f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122fc3f3",
  null
  
)

export default component.exports